import { render } from "./EditGoalSideOver.vue?vue&type=template&id=3c9f3871&scoped=true"
import script from "./EditGoalSideOver.vue?vue&type=script&lang=js"
export * from "./EditGoalSideOver.vue?vue&type=script&lang=js"

import "./EditGoalSideOver.vue?vue&type=style&index=0&id=3c9f3871&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9f3871"]])

export default __exports__